export default function PublishChecklist({ errorsConcepts, errorsConditions, errorsItems, }) {
  return (
    <div>
      {/* 🚨 MENSAJE DE BLOQUEO */}
      {(errorsConcepts || errorsItems) && (
        <div className="alert alert-danger mb-3">
          <strong>No es posible publicar la tarifa.</strong>
          <ul className="mb-0">
            {errorsConcepts && (
              <li>No hay conceptos tarifarios definidos.</li>
            )}
            {errorsItems && (
              <li>Existen ítems sin valor o con valores inválidos.</li>
            )}
          </ul>
          <small>
            Corrija la información y guarde los cambios antes de publicar.
          </small>
        </div>
      )}

      {(errorsConditions) && (
        <div className="alert alert-warning mb-3">
          <strong>Advertencias para revisar antes de publicar la tarifa.</strong>
          <ul className="mb-0">
            {errorsConditions && (
              <li>No hay condiciones configuradas.</li>
            )}
          </ul>
          <small>
            Recuerde guardar los cambios antes de publicar.
          </small>
        </div>
      )}

      {/* … resto del review */}
    </div>
  );
}
